import S from 'common/service/sanctuary';
import { eqBy } from 'ramda';
import { createSelector } from 'reselect';
import { getCollectionMaybe } from '../collection/selectors';

// we should not expose selection itself, as it might duplicate source of truth
const getSelected$ = S.get(S.compose(S.isJust, S.toMaybe), 'selected');

export const isSelected = (equalsBy = S.I) => createSelector(
  getSelected$,
  selection => item => S.maybe(
    false,
    eqBy(equalsBy, item),
    selection,
  ),
);

export const getSelected = (equalsBy = S.prop('id')) => createSelector(
  getSelected$,
  getCollectionMaybe,
  isSelected(equalsBy),
  (selection, maybeCollection, isItemSelected) => S.chain(
    () => S.chain(S.find(isItemSelected), maybeCollection),
    selection,
  ),
);

export const factory = (getScope, equalsBy = S.prop('id')) => ({
  isSelected: createSelector(
    state => getScope(state),
    isSelected(equalsBy),
  ),
  getSelected: createSelector(
    getScope,
    getSelected(equalsBy),
  ),
});

export default factory;
